<template>
<div id="ContainerHcpcsCPT">
       <h4 v-if="this.$attrs.editMode" class="page-title text-truncate">
        {{$t('placeofservice.Edit')}}
      </h4>
      <h4 v-if="!this.$attrs.editMode" class="page-title text-truncate">
        {{$t('placeofservice.Add')}}          
      </h4>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                     v-model="PlaceOfService.code"                    
                     v-bind:Label="$t('Shared.Code')"          
                     v-bind:isReadOnly="this.$attrs.editMode"
                     v-bind:isRequired="true"
                     v-bind:MaxLengthProp="2"
                     v-bind:isValid="isPlaceOfServiceValid"
                     v-on:blur="OnCodeBlur(PlaceOfService.code)"
                     :InvalidFeedback="$t('placeofservice.PlaceRequired')"
                     :SearchFieldCode="'Code'"
                     v-bind:Id="'input_pos'"
                  />
            </b-col>  
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                     v-model="PlaceOfService.posname"     
                     v-bind:MaxLengthProp="50"               
                     v-bind:Label="$t('Shared.Description')" 
                     v-bind:Id="'input_desc'" 
                  />
            </b-col> 
             
        </b-row>
       

    <div class="page-actions">      
     <MdButton
               v-bind:Label="$t('placeofservice.PlaceList')"
               v-bind:Name="'btnbtn_save_PlaceOfServicelist'"
               v-bind:ClassProp="'secondary mx-2 btn-login'"
               v-on:click="DiscardChanges"/>    
        <MdButton
            v-bind:Label="$t('Shared.Save')"
            v-bind:ClassProp="(this.isReadOnlyPlaceOfService)?'primary mx-2':'primary btn-login mx-2'"
            v-on:click="SaveOrEdit"
            v-bind:isReadOnly="isReadOnlyPlaceOfService"
            v-bind:Name="'btn_save_PlaceOfService'"/>
    </div>

</div>
</template>

<script>


import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import PlaceOfService from '@/services/placeofservice.service'
import { EventBus } from '../../../../event-bus.js';
import Permission from '@/common/Permission'
//import Utils from '@/common/utils'

let elemSaveBtn = '';
export default {
    /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iPI = await vm.CanViewAllowed();           
            if(iPI) next()
            else next('/accessdenied');
        }) 
    },*/

    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
                this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                title: this.$t('Admission.Admission'),
                okTitle: this.$t('Shared.BtnSave'),
                cancelTitle: this.$t('Shared.BtnDismiss'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning'
            })
            .then(async value => {
                if(!value){
                    next();
                } else {
                    await this.SaveOrEdit();
                    next();
                }
            })		
        } else {
            next()
        }
    },

  name: 'PlaceOfService',
 mixins: [ShowMessage, DBFunctions, Permission/*,EventBus*/],
  data(){
    return{
        parameter:{
            SearchCriteria:'',
            PageNumber : 1,
            PageSize:0,         
        },
       PlaceOfService:{
        code:"",
        posname:""      
       },
       //Menu : this.$store.state.leftMenu,
       //permission:[],
       pendingChanges:false,
        isReadOnlyPlaceOfService:false,
      isPlaceOfServiceValid:true,
      CodeExist:false,
        OptionsRightMenu:{
          visible:false,
          ItemsList:[],
          btnvisible:false,
          itemdisabled: false,
          PatientCode:'',
          Mode:this.edit_mode,
          favButtonAtion:false          
        },

    }
  },

  methods:{

    DiscardChanges(){
       this.checkExistFavorite('/app/placeofservices');
       this.$router.push({ name: "placeofservice-List" });
    },

      
  /*CanViewAllowed(){
      return this.permission[0].roleCanView;
  },*/
  

    AddPlaceOfService(){
      if(!this.CodeExist){
      this.$emit('load', true);
      PlaceOfService.AddPlaceOfService(this.PlaceOfService)
                .then((response) => {
                    if(response.status == '200'){
                        this.PlaceOfService = response.data; 
                        this.pendingChanges = false;   
                        this.$emit('load', false);
                        /*if(!this.OffRoute){
                           this.GotoAdmissionList();
                        }*/
                        this.$router.push({name: "placeofservice-List"}).catch(()=>{});
                      
                        setTimeout(() => 
                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50); 
                    }                             
                })				
                .catch((error) => {   
                    /*if (!error.response) {
                   this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToInsert'),"error");
                      }                      
                     else if(error.response.status === 400 ){
                        this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }*/
                    elemSaveBtn.removeAttribute("disabled"); 
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
      }else{
        this.showMessage(this.$tc('Msg.Error'),this.$t('placeofservice.PlaceExist'),"error");
      }
    },

     OnCodeBlur(value){           
          if(!this.$attrs.editMode){           
            if (value.trim()!== '') {          
            var parameter = {
               "code":value
            };
            PlaceOfService.getPlaceOfServiceByCode(parameter)
                .then((response) => {
                    if(response.status == '200' && response.data){
                      // this.$emit('load', false);  
                       if(response.data.length > 0){
                          this.showMessage(this.$tc('Msg.Error'),this.$t('placeofservice.PlaceExist'),"error");
                          this.CodeExist = true;
                       }else{
                           this.CodeExist = false;
                       } 
                    }  
                     this.$emit('load', false);                          
                })
                .catch((error) => {
                    this.$emit('load', false);                  
                  /*if(error.response.status !== 404 && error.response.status !== 500){
                      if(error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  }*/
                    this.showResponseErrorMessage(error);
                    
                });  
            }
               }
    
       },


    EditPlaceOfService(){
      this.$emit('load', true);
     /* var data = {
        posName : this.PlaceOfService.posName
      }*/
      PlaceOfService.UpdatePlaceOfService(this.$route.params.id,this.PlaceOfService)
                .then((response) => {
                    if(response.status == '200'){
                        this.PlaceOfService = response.data; 
                        this.pendingChanges = false;   
                        this.$emit('load', false);
                        /*if(!this.OffRoute){
                           this.GotoAdmissionList();
                        }*/
                        this.$router.push({name: "placeofservice-List"}).catch(()=>{});
                      
                        setTimeout(() => 
                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50); 
                    }                             
                })
                .catch((error) => {   
                    /*if (!error.response) {
                   this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToInsert'),"error");
                      }                      
                     else if(error.response.status === 400 ){
                        this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }*/
                     elemSaveBtn.removeAttribute("disabled"); 
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
    },

  getPlaceOfService(){
      if(this.$attrs.editMode){
      this.$emit('load', true);     
      PlaceOfService.get(this.$route.params.id)
        .then((response) => {
            if(response.status == '200' && response.data){
              this.PlaceOfService = response.data; 
             /* if(this.PlaceOfService){
                this.PlaceOfService.PosName = this.PlaceOfService.posName;
              }*/
            }   
              this.$emit('load', false);                     
        })
        .catch((error) => {                    
            /*if (!error.response) {
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToSave'),"error");
            }                      
            else if(error.response.status === 400 ){
              this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            }
            else if(error.response.status === 405 ){             
                  this.$router.push({name: "Main"});    
                    setTimeout(() => 
                        this.showPermissionMessage()
                        , 50);            
            } 
            else if(error.response.status === 500){
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
            } else{
              this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            } */
            this.$emit('load', false);           
            this.showResponseErrorMessage(error); 
        }); 
    
      }
    },

      DoAction(){     
        !this.$attrs.editMode ? this.AddPlaceOfService() : this.EditPlaceOfService(); 
      },

      SaveOrEdit(){ 
         if (this.validate_required()) {
            this.DoAction();
         } else {
            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");          
         }

      },

      validate_required() {
        this.isPlaceOfServiceValid = this.PlaceOfService.code.length > 0 ? true : false;   
        return this.isPlaceOfServiceValid;
      }
      ,
      checkUserAction() {
        if (elemSaveBtn.disabled) {
          elemSaveBtn.removeAttribute('disabled');
        }
      },

        beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''	
			}
		}
  },

    created(){
        this.InitializePermissions(!this.$attrs.editMode ? 'AddView' : 'EditView');
        if (!this.IsAccessAllowed()) {
            return;
        }

        EventBus.$on("onChanged", function (e) {   
            this.pendingChanges = e.Changed;     
            this.checkUserAction();
        }.bind(this));
        //this.getPermissionLeftMenu(this.Menu,this.$route.path,this.permission);
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

  mounted(){
        if (!this.IsAccessAllowed()) {
            return;
        }

          this.OptionsRightMenu.ItemsList = [];
       let layoutStatus = this.$store.state.layoutStatus;
       switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }
      this.getPlaceOfService();
      setTimeout( function() {
         elemSaveBtn = document.getElementById('btn_save_PlaceOfService');
         elemSaveBtn.setAttribute('disabled','');
      }, 50, this ); 
  },

    destroyed(){
      this.OptionsRightMenu.ItemsList = [];
      this.OptionsRightMenu.Mode = false;
      this.OptionsRightMenu.visible = false; 
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy () {
        if (!this.IsAccessAllowed()) {
            return;
        }
        
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    },
   
};
</script>


